import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'ceil'
})
export class CeilPipe implements PipeTransform {

  transform(value: number): number {
    const val = value < 0 ? value * -1 : value;
    return Math.ceil(val);
  }

}
